// Sätt standard uppspelningshastighet för alla produktvideor
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.product-media-container video').forEach(function (video) {
    video.playbackRate = 1.75; // Ändra till önskad hastighet
  });

  // Fångar även videos som laddas in senare (deferred)
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeName === 'VIDEO') {
          node.playbackRate = 1.50;
        }
        if (node.querySelectorAll) {
          node.querySelectorAll('video').forEach(function (video) {
            video.playbackRate = 1.50;
          });
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
});


